<form class="row"
      novalidate
      [formGroup]="form"
      (keyup.enter)="submit()"
>
  <div class="col-12">
    <div class="p-field">
      <div class="p-field__title">
        <label class="text--md" for="input-email">Email</label>
        <app-icon-feather *ngIf="username.valid" icon="check-circle"></app-icon-feather>
        <app-icon-feather *ngIf="username.dirty && username.invalid" icon="x-circle"></app-icon-feather>
      </div>
      <input id="input-email"
             type="text"
             pInputText
             placeholder="your@email.com"
             name="username"
             [formControl]="username"
      >
      <div class="position-relative">
        <small class="p-error"
               *ngIf="username.dirty && username.invalid"
        >
          {{ getErrorMessage('Email', username) }}
        </small>
      </div>
    </div>
  </div>

  <!-- <div class="col-12 mt-5"
       *ngIf="isProduction"
  >
    <recaptcha [formControl]="captcha"></recaptcha>
    <div class="p-field">
      <div class="position-relative">
        <small class="p-error"
               *ngIf="captcha.dirty && captcha.invalid"
        >
          {{ getErrorMessage('Captcha', captcha) }}
        </small>
      </div>
    </div>
  </div> -->

  <div class="col-12 mt-5">
    <button pButton
            class="p-button-md w-100"
            type="submit"
            label="SEND"
            [disabled]="form.invalid"
            (click)="submit()"
    ></button>
  </div>

  <div class="col-12 mt-3">
    <p>
      Back to
      <a class="p-link"
         routerLink="/auth/login"
      >
        Login page
      </a>
    </p>
  </div>
</form>

